import { render, staticRenderFns } from "./RankingPresupuestosCliente.vue?vue&type=template&id=08f2db35&"
import script from "./RankingPresupuestosCliente.vue?vue&type=script&lang=js&"
export * from "./RankingPresupuestosCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports